// extracted by mini-css-extract-plugin
module.exports = {"customDropdownSize":"Dropdownstyle_customDropdownSize__-GEmD"};